<!-- <app-quote-progress [progress$]="progress$" [busy]="displayProgress$ | async"></app-quote-progress> -->
<app-progress-background [progress]="progress$ | async" [state]="(quotingStarted$ | async) ? ((displayProgress$ | async) ? 'busy' : 'done') : 'inactive'"></app-progress-background>
<app-context-notices [notices$]="notices$"></app-context-notices>
@for (notice of noServiceNotices$ | async; track notice) {
    <div class="no-service-notice">
        {{ notice.text }}
    </div>
}
<div class="quotes" #cardDisplay>
  @for (data of displayQuotes$ | async; track quoteTrack($index, data)) {
    <div class="card-entry" [class.selected]="data.selected">
      <div class="quote-information" [style.left]="data.infoX" [style.width]="data.infoWidth">
        <app-price-breakdown
          [price]="data.quote.customer"
          [comparison]="data.quote.list"
          [comparisonRatio]="data.quote.listCurrencyConversion">
        </app-price-breakdown>
        <div class="quote-notes">
          @for (note of data.quote.notes; track note) {
            <div class="quote-note">
              <app-icon icon="courier-note"></app-icon> <span>{{ note.message }}</span>
            </div>
          }
        </div>
        <div class="quote-buttons flex flex-row gap-2">
          <button mat-raised-button (click)="clearFocus()" i18n>BACK</button>
          <button mat-raised-button color="primary" (click)="ship(data.quote)" i18n>SHIP</button>
        </div>
        <div class="partner-data flex md:flex-row flex-col gap-4">
          @if (data.quote.courierAccountNumber) {
            <dl>
              <dt i18n>Account</dt>
              <dd>{{ data.quote.courierAccountNumber }}</dd>
            </dl>
          }
          @if (!!data.quote.cost) {
            <dl>
              <dt i18n>Cost</dt>
              <dd>
                <app-price-breakdown
                  [price]="data.quote.cost">
                </app-price-breakdown>
              </dd>
            </dl>
          }
          @if (!!data.quote.reseller && !!data.quote.cost) {
            <dl>
              <dt i18n>Reseller</dt>
              <dd>
                <app-price-breakdown
                  [price]="data.quote.reseller">
                </app-price-breakdown>
              </dd>
            </dl>
          }
          @if (!!data.quote.list && !!data.quote.cost) {
            <dl>
              <dt i18n>List</dt>
              <dd>
                <app-price-breakdown
                  [price]="data.quote.list">
                </app-price-breakdown>
              </dd>
            </dl>
          }
        </div>
      </div>
      <div class="card-holder" [style.left]="data.x" [style.top]="data.y" [style.transform]="data.transform">
        <div class="card-container" @card (click)="selectQuote(data.selected ? null : data.quote)">
          <app-quote-card [shipment]="shipment" [quote]="data.quote"></app-quote-card>
        </div>
      </div>
    </div>
  }
</div>
